import React, { useContext, useEffect, useState } from "react";
import Input from "../../shared/components/Input";
import useForm from "../../shared/hooks/form-hooks";
import {
  VALIDATOR_EMIAL,
  VALIDATOR_NUMBER_ONLY,
  VALIDATOR_REQUIRE,
  VALIDATOR_VALIDATED,
} from "../../shared/util/validators";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EditIcon from "@mui/icons-material/Edit";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Unstable_Grid2";
import { useSnackbar } from "notistack";
import { useDispatch } from "react-redux";
import { baseUrl } from "../../baseUrl";
import { AuthContext } from "../../context/AuthContext";

const x = "hello";

const DoctorDetails = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [imessage, setMessage] = useState();
  const [snackMode, setSnackMode] = useState("warning");
  const [handler, setHandler] = useState(false);

  const auth = useContext(AuthContext);
  const dispatch = useDispatch();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [formState, inputHandler, setFormData] = useForm(
    {
      name: {
        value: props.name,
        isValid: false,
      },
      contactNumber: {
        value: props.contactNumber,
        isValid: true,
      },
      email: {
        value: props.email,
        isValid: true,
      },
      token: {
        value: props.token,
        isvalid: true,
      },
      address: {
        value: props.address,
        isValid: true,
      },
    },
    false
  );

  useEffect(() => {
    setFormData(
      {
        name: {
          value: props.name,
          isValid: true,
        },
        contactNumber: {
          value: props.contactNumber,
          isValid: true,
        },
        email: {
          value: props.email,
          isValid: true,
        },
        token: {
          value: props.token,
          isValid: true,
        },
        address: {
          value: props.address,
          isValid: true,
        },
      },
      true
    );
    setIsLoading(false);
  }, [setFormData, props.open]);

  const doctorUpdateHandler = async (event) => {
    setIsLoading(true);
    try {
      const response = await fetch(
        baseUrl + "/api/v1/laboratorys/update-doctor",
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            authorization: auth.token,
          },
          body: JSON.stringify({
            id: props.id,
            contactNumber: formState.inputs.contactNumber.value,
            address: formState.inputs.address.value,
            email: formState.inputs.email.value,
            name: formState.inputs.name.value,
            doctorToken: formState.inputs.token.value,
          }),
        }
      );

      const responseData = await response.json();

      if (!response.ok) {
        // Handle error based on responseData structure
        if (responseData.message && responseData.data) {
          const messages = responseData.data;
          if (Array.isArray(messages)) {
            messages.forEach((message) => {
              enqueueSnackbar(message, { variant: "error" });
            });
          } else {
            enqueueSnackbar(responseData.message.message, { variant: "error" });
          }
        } else {
          throw new Error("An unexpected error occurred");
        }
        throw new Error(responseData.message.message);
      } else {
        enqueueSnackbar(responseData.message.message, {
          variant: "success",
        });
      }

      setIsLoading(false);
      dispatch({
        type: "update_doctor_table",
      });
    } catch (err) {
      setIsLoading(false);

      console.error(err); // This will log the actual error

      const messages =
        err.response && err.response.data && Array.isArray(err.response.data)
          ? err.response.data
          : err.message;

      if (Array.isArray(messages)) {
        messages.forEach((message) => {
          enqueueSnackbar(message, { variant: "error" });
        });
      } else {
        enqueueSnackbar(messages, { variant: "error" });
      }
    }

    props.close();
  };

  if (isLoading) {
    return (
      <div style={{ justifyContent: "center", display: "flex" }}>
        <CircularProgress color="inherit" />
      </div>
    );
  }
  return (
    <React.Fragment>
      <form onSubmit={doctorUpdateHandler}>
        <Paper sx={{ flexGrow: 1, maxWidth: 1200, p: 2, m: 1 }} elevation={2}>
          <Grid container spacing={1}>
            <Grid md={6} xs={12}>
              <Input
                id="name"
                element="input"
                label="نام پزشک"
                validators={[VALIDATOR_REQUIRE()]}
                errorText="لطفا نام پزشک را وارد کنید"
                initialValue={formState.inputs.name.value}
                inputValid={formState.inputs.name.isValid}
                onInput={inputHandler}
              />
            </Grid>
            <Grid md={6} xs={12}>
              <Input
                id="contactNumber"
                element="number_only"
                label="شماره تماس"
                validators={[VALIDATOR_VALIDATED(), VALIDATOR_NUMBER_ONLY()]}
                errorText="لطفا شماره تماس پزشک را وارد کنید. مقدار وارد شده باید فقط شامل اعداد باشد."
                initialValue={formState.inputs.contactNumber.value}
                inputValid={formState.inputs.contactNumber.isValid}
                onInput={inputHandler}
              />
            </Grid>
            <Grid md={6} xs={12}>
              <Input
                id="email"
                element="input"
                label="ایمیل"
                validators={[VALIDATOR_VALIDATED(), VALIDATOR_EMIAL()]}
                errorText="لطفا ایمیل پزشک را وارد کنید. (فرمت صحیح ایمیل به صورت abc@example.com می‌باشد.)"
                initialValue={formState.inputs.email.value}
                inputValid={formState.inputs.email.isValid}
                onInput={inputHandler}
              />
            </Grid>
            <Grid md={6} xs={12}>
              <Input
                id="token"
                element="input"
                label="توکن"
                validators={[VALIDATOR_VALIDATED()]}
                errorText=""
                initialValue={formState.inputs.token.value}
                inputValid={formState.inputs.token.isValid}
                onInput={inputHandler}
              />
            </Grid>
            <Grid md={12} xs={12}>
              <Input
                id="address"
                element="input"
                label="آدرس"
                validators={[VALIDATOR_VALIDATED()]}
                errorText=""
                initialValue={formState.inputs.address.value}
                inputValid={formState.inputs.address.isValid}
                onInput={inputHandler}
                multiline={true}
              />
            </Grid>
            <Grid xs={12} md={6}>
              <Button
                disabled={!formState.isValid}
                type="submit"
                fullWidth
                color="secondary"
                variant="contained"
              >
                <EditIcon />
              </Button>
            </Grid>
            <Grid xs={12} md={6}>
              <Button
                fullWidth
                color="primary"
                variant="contained"
                onClick={props.close}
              >
                <ArrowBackIcon />
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </form>
    </React.Fragment>
  );
};

export default DoctorDetails;
